import i18n from "@/i18n/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "Myopia",
      text: `${i18n.global.t("enums.visionType.Myopia")}`,
    },
    {
      value: 1,
      name: "Hyperopia",
      text: `${i18n.global.t("enums.visionType.Hyperopia")}`,
    },
    {
      value: 2,
      name: "Contacts",
      text: `${i18n.global.t("enums.visionType.Contacts")}`,
    },
    {
      value: 3,
      name: "Other",
      text: `${i18n.global.t("enums.visionType.Other")}`,
    },
    {
      value: 4,
      name: "Multifocal",
      text: `${i18n.global.t("enums.visionType.Multifocal")}`,
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
